import { Component, OnInit } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { User } from "src/app/model/user/user";
import { DialogService } from "src/service/dialog.service";
import { UserService } from "src/service/user.service";
import { CheckoutService } from "../checkout.service";
import {AddressService} from '../../../../service/address.service';

@Component({
  selector: "app-cargo",
  templateUrl: "./cargo.component.html",
  styleUrls: ["../../dashboard.style.scss"],
})
export class CargoComponent implements OnInit {
  constructor(
    public userService: UserService,
    private checkoutService: CheckoutService,
    private addressService: AddressService,
    private route: ActivatedRoute,
    private router: Router,
    private dialogService: DialogService
  ) {}

  ngOnInit(): void {}

  onContinue() {
    const user: User = this.userService.user.value;

    this.addressService.getCountryListForCargo().subscribe(list => {

      if (!list.find(c => c.englishName.toLowerCase() === user.country.toLowerCase())) {
        this.dialogService.showErrorDialog("NEED_COUNTRY_ADDRESS_NEW");
        return;
      }
      this.checkoutService.refreshCheckout({
        address: user.additionalAddress,
        country: user.country,
        city: user.city,
        no: user.postCode,
        zipcode: user.postCode,
      });

      this.router.navigate(["..", "payment"], { relativeTo: this.route });
    });

    // if (!this.checkoutService.germanyTranslates.includes(user.country)) {
    //   this.dialogService.showErrorDialog("NEED_COUNTRY_ADDRESS_NEW");
    //   return;
    // }
    //
    // this.checkoutService.refreshCheckout({
    //   address: user.additionalAddress,
    //   country: user.country,
    //   city: user.city,
    //   no: user.postCode,
    //   zipcode: user.postCode,
    // });
    //
    // this.router.navigate(["..", "payment"], { relativeTo: this.route });
  }
}
